import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { withTranslation } from "react-i18next";
import { getWeighBridgeTSSCTPWiseSummary, getZoneDetails } from "../../../../Apis/ttrReportsApi";
import Header from "../../../../Common/Header/header";
import Sidebar from "../../../../Common/Sidebar/sidebar";
import { useLocation } from "react-router-dom";
import DataTable from "react-data-table-component";
import isGHMC from "../../../../Common/helper/helpar";

const TSSCTPForULB = ({ t }) => {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const [zoneData, setZoneData] = useState([]);
    const [TSSCTPData, setTSSCTPData] = useState([]);
    const [fetchTSSCTPData, setFetchTSSCTPData] = useState([]);
    const location = useLocation();
    const isProd = isGHMC();

    const fetchZoneData = async () => {
        try {
            const response = await getZoneDetails();
            setZoneData(response.data);
            // console.log(response.data, '--zone data from tssctp--')
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        fetchZoneData();
    }, [])

    useEffect(() => {
        if (location.state && location.state.data) {
            const newData = location.state.data.Data.map(item => {
                return {
                    ...item,
                    ULB_Tonnage: (item.sum_ULB / 1000).toFixed(2),
                    ULB_Trips: item.count_ULB,
                };
            });

            setFetchTSSCTPData(newData);
        }
    }, [location.state]);

    const fetchTSSCTP = async (data) => {
        try {
            await new Promise(resolve => setTimeout(resolve, 1000));
            const FromDate = data && data.FromDate ? data.FromDate : "";
            const ToDate = data && data.ToDate ? data.ToDate : "";
            const zoneId = data && data.zoneId ? data.zoneId : "";
            const requestData = {
                FromDate,
                ToDate,
                zoneId,
                ulb: 1,
            };
            const response = await getWeighBridgeTSSCTPWiseSummary(requestData);
            const newData = response.data.Data.map(item => {
                return {
                    ...item,
                    ULB_Tonnage: (item.sum_ULB / 1000).toFixed(2),
                    ULB_Trips: item.count_ULB,
                };
            });
            setFetchTSSCTPData(newData);
            // console.log(newData, 'newData --------- fetch TSSCTP')
        } catch (error) {
            console.log(error)
        }
    }

    const customStyles = {
        rows: {
            style: {},
        },
        headCells: {
            style: {
                paddingLeft: '8px',
                paddingRight: '8px',
                color: 'black',
                backgroundColor: 'rgb(204, 204, 204)',
                fontFamily: 'Poppins',
                fontWeight: '600',
            },
        },
        cells: {
            style: {
                paddingLeft: '8px',
                paddingRight: '8px',
            },
        },
    }
    const UlbColumns = [
        {
            name: 'Sl.No',
            selector: (row) => row['slno'],
            sortable: true,
            format: (row, rowIndex) => rowIndex + 1,
        },
        {
            name: 'zoneName',
            selector: (row) => row['zoneName'],
            sortable: true,
        },
        {
            name: 'ULB_Trips',
            selector: (row) => row['ULB_Trips'],
            sortable: true,
        },
        {
            name: 'ULB_Tonnage',
            selector: (row) => row['ULB_Tonnage'],
            sortable: true,
        },
    ]

    // Calculate totals
    const totalULB_Trips = fetchTSSCTPData.reduce((total, item) => total + item.ULB_Trips, 0);
    const totalULB_Tonnage = fetchTSSCTPData.reduce((total, item) => total + parseFloat(item.ULB_Tonnage), 0).toFixed(2);

    // Add an extra row for total
    const totalRow = {
        slno: "Total",
        zoneName: "Total",
        ULB_Trips: totalULB_Trips,
        ULB_Tonnage: totalULB_Tonnage,
    };

    // Combine the original data with the total row
    const tableData = [...fetchTSSCTPData, totalRow];

    return (
        <>
            <div style={{ width: "100%" }} className={`${isProd ? "ghmc-true" : "ghmc-false"} App`}>
                <Header />
                <Sidebar />
                <div className="content">
                    <div className="page-content">
                        <div className="page-header">
                            <div className="text-end mb-3">
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit(fetchTSSCTP)}>
                                    <div className="row" style={{ textAlign: "left" }}>
                                        <div className="col-md-3 mb-3">
                                            <label>Select From Date:</label>
                                            <input
                                                className="form-control"
                                                type="datetime-local"
                                                name="FromDate"
                                                {...register("FromDate")}
                                                style={{ backgroundColor: "#fff" }}
                                            />
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <label>Select To Date:</label>
                                            <input
                                                className="form-control"
                                                type="datetime-local"
                                                name="ToDate"
                                                {...register("ToDate")}
                                                style={{ backgroundColor: "#fff" }}
                                            />
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <label>Select Zone:</label>
                                            <select
                                                className="form-select"
                                                name="zoneId"
                                                {...register("zoneId")}
                                                style={{ backgroundColor: "#fff" }}
                                            >
                                                <option value="">--select--</option>
                                                {zoneData.map((zone) => (
                                                    <option value={zone.zoneId}>{zone.zoneName}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div
                                            className="col text-left"
                                            style={{ display: "flex", justifyContent: "flex-end" }}
                                        >
                                            <button
                                                type="submit"
                                                style={{
                                                    borderRadius: "20px",
                                                    width: "100px",
                                                    display: "flex",
                                                    height: "40px",
                                                    justifyContent: "center",
                                                    backgroundColor: "red",
                                                    color: "#fff",
                                                    border: "none",
                                                    alignItems: "center",
                                                }}
                                            >
                                                Search
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="card mt-3">
                                <div className="card-body">
                                    <div className="top-header">
                                        <span>{t("Zone Wise Reporting of TS/ SCTP, Trips & Tonnage Summary")} </span>
                                    </div>
                                    <DataTable
                                        columns={UlbColumns}
                                        customStyles={customStyles}
                                        data={location.state && location.state.data ? tableData : TSSCTPData}
                                        pagination
                                        highlightOnHover
                                        noDataComponent="Loading..."
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default withTranslation()(TSSCTPForULB);